'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialGithubCircular = function TiSocialGithubCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 35c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z m0-26.7c-6.4 0-11.7 5.3-11.7 11.7s5.3 11.7 11.7 11.7 11.7-5.3 11.7-11.7-5.3-11.7-11.7-11.7z m2.6 12.7c0.3 0 0.5 0.2 0.7 0.5 0.3 0.3 0.4 0.6 0.4 1 0 0.4-0.1 0.8-0.4 1.1s-0.4 0.4-0.7 0.4c-0.3 0-0.6-0.2-0.8-0.4-0.2-0.3-0.3-0.7-0.3-1.1s0.1-0.7 0.3-1c0.2-0.3 0.5-0.5 0.8-0.5z m3.7-3.8c0.8 0.9 1.2 2 1.2 3.2 0 0.8-0.1 1.5-0.3 2.2-0.2 0.6-0.4 1.1-0.7 1.5-0.3 0.4-0.6 0.8-1 1.1-0.4 0.3-0.8 0.5-1.2 0.7-0.3 0.1-0.7 0.2-1.2 0.3-0.4 0.1-0.7 0.1-1 0.1-0.2 0-0.4 0-0.7 0-0.1 0-0.3 0-0.6 0-0.3 0.1-0.6 0.1-0.8 0.1s-0.5 0-0.8-0.1c-0.3 0-0.5 0-0.6 0-0.3 0-0.5 0-0.7 0-0.3 0-0.6 0-1-0.1-0.5-0.1-0.9-0.2-1.2-0.3-0.4-0.2-0.8-0.4-1.2-0.7-0.4-0.3-0.7-0.7-1-1.1-0.3-0.4-0.5-0.9-0.7-1.5-0.2-0.7-0.3-1.4-0.3-2.2 0-1.2 0.4-2.3 1.2-3.2-0.1 0-0.1-0.4 0-1.3 0.1-0.8 0.2-1.6 0.5-2.3 1 0.1 2.3 0.7 3.7 1.7 0.5-0.1 1.2-0.2 2.1-0.2 0.9 0 1.6 0.1 2.1 0.2 0.6-0.4 1.3-0.8 1.9-1.1 0.6-0.3 1.1-0.4 1.3-0.5l0.5-0.1c0.3 0.7 0.4 1.5 0.5 2.3 0.1 0.9 0.1 1.3 0 1.3z m-6.3 8.4c1.8 0 3.2-0.2 4.1-0.6 0.9-0.5 1.4-1.4 1.4-2.7 0-0.8-0.3-1.5-0.9-2-0.3-0.3-0.6-0.4-1-0.5-0.4-0.1-1-0.1-1.9 0-0.8 0.1-1.4 0.1-1.7 0.1-0.4 0-0.8 0-1.4-0.1-0.5 0-1 0-1.3 0-0.3-0.1-0.6 0-1 0.1-0.4 0.1-0.7 0.2-0.9 0.4-0.6 0.5-0.9 1.2-0.9 2 0 1.3 0.5 2.2 1.4 2.7 0.9 0.4 2.3 0.6 4.1 0.6z m-2.6-4.6c0.3 0 0.6 0.2 0.8 0.5 0.2 0.2 0.3 0.6 0.3 1 0 0.4-0.1 0.8-0.3 1.1-0.2 0.2-0.5 0.4-0.8 0.4-0.3 0-0.5-0.2-0.7-0.4-0.3-0.3-0.4-0.7-0.4-1.1s0.1-0.8 0.4-1c0.2-0.3 0.4-0.5 0.7-0.5z' })
        )
    );
};

exports.default = TiSocialGithubCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-github-circular.js
// module id = 3716
// module chunks = 0